// == Import npm
import React from "react";
import { Modal, Steps } from "antd";

// == Import SCSS
import "./modalUpdate.less";

// == Import icons

// == Import components
import FormUpdate from "./FormUpdate/FormUpdate";

const { Step } = Steps;

const ModalUpdate = ({ isVisible, setVisible, visitorCheck, typeVisitor, setVisitorCheck }) => {
  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const [current, setCurrent] = React.useState(0);

  return (
    <div>
      <Modal
        width="630px"
        visible={isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        {visitorCheck.length === 1 ? null : (
          <Steps current={current} labelPlacement="vertical" progressDot={true}>
            {visitorCheck.map((visitor, index) => (
              <Step key={visitor.id} title={`${visitor.lastname}`} />
            ))}
          </Steps>
        )}

        <div className="steps-content">
          {visitorCheck[current] !== undefined && (
            <FormUpdate
              typeVisitor={typeVisitor}
              user={visitorCheck[current]}
              setVisitorCheck={setVisitorCheck}
              visitorCheck={visitorCheck}
              setVisible={setVisible}
              current={current}
              setCurrent={setCurrent}
              onNext={
                current === visitorCheck.length - 1
                  ? () => {
                      //setCurrent(0);
                    }
                  : () => setCurrent(current + 1)
              }
              onPrevious={current !== 0 ? () => setCurrent(current - 1) : null}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ModalUpdate;
